module.exports = __webpack_public_path__ + "static/media/add-icon.b53072a1.svg";